import React from 'react';
import PropTypes from 'prop-types';
import { SelectField, MenuItem } from 'material-ui';
import { Box } from '@material-ui/core';
import SelectorChips from '../../common/Selector/SelectorChips';
import { dropDownStyle, common } from '../../../theme/AllocateBaseTheme';

const SelectFilter = ({ key, value, options, onChange, classes, customStyle = {}, fullWidth, multiple }) => {
  const handleSelectChange = (event, identifier, selectedIds) => {
    const isEmpty = !selectedIds.length;
    const isAllSelected = options.every(o => selectedIds.some(id => o.id === id));
    const isLastSelectedAny = selectedIds.at(-1) === 0;

    const validSelectedIds = isEmpty || isAllSelected || isLastSelectedAny ? [0] : selectedIds.filter(id => id !== 0);
    onChange(validSelectedIds);
  };

  const handleChipDelete = id => () => {
    const filteredValues = value.filter(v => v !== id);
    onChange(filteredValues.length > 0 ? filteredValues : [0]);
  };

  return (
    <Box style={{ width: 'calc(100% - 80px)' }} display="flex" flexDirection="column">
      <SelectField
        value={value}
        onChange={handleSelectChange}
        multiple={multiple}
        fullWidth={fullWidth}
        floatingLabelStyle={common.floatingLabelStyle}
        floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
        floatingLabelFocusStyle={common.floatingLabelFocusStyle}
        underlineStyle={common.underlineStyle}
        style={customStyle.selector}
        iconStyle={dropDownStyle.iconStyle}
        labelStyle={dropDownStyle.labelStyle}
        menuStyle={dropDownStyle.menuStyle}
        inputStyle={dropDownStyle.inputStyle}
      >
        {multiple && <MenuItem id={0} key={`${key}Any`} value={0} primaryText={'Any'} />}
        {options.map(option => (
          <MenuItem id={option.id} key={`${key}${option.name}`} value={option.id} primaryText={option.name} />
        ))}
      </SelectField>
      {multiple && Array.isArray(value) && value.length > 0 && (
        <SelectorChips
          style={classes.selectorChip}
          options={options}
          value={value}
          handleRequestDelete={handleChipDelete}
        />
      )}
    </Box>
  );
};

SelectFilter.propTypes = {
  key: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  multiple: PropTypes.bool,
};

SelectFilter.defaultProps = {
  multiple: true,
  placeholder: 'Any',
  onChipDelete: () => {},
  fullWidth: true,
};

export default SelectFilter;
